import { render, staticRenderFns } from "./UiTip.vue?vue&type=template&id=3ed0e885&"
import script from "./UiTip.vue?vue&type=script&lang=js&"
export * from "./UiTip.vue?vue&type=script&lang=js&"
import style0 from "./UiTip.vue?vue&type=style&index=0&id=3ed0e885&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports